import React from "react";
import IconDot from "react-icons/lib/md/fiber-manual-record";
import { browserHistory } from "react-router";
import { Card, CardBlock, CardGroup, CardTitle, Row } from "reactstrap";
import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { getRequest } from "../../utils/apiUtils";

var axios = require("axios");

var dateFormat = require("dateformat");

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      LatestAuditList: [],
      AuditsCount: [],
      GraphData: [],
    };
  }
  componentDidMount() {
    var that = this;
    getRequest({ url: "/api/get_all_audit" })
      .then(function (response) {
        console.log("🚀 ~ extends ~ response:", response.data);
        if (response.data != "" && response.data != null && response.data.result.length > 0) {
          that.setState({
            LatestAuditList: response.data.result,
          });
        } else {
          that.setState({
            LatestAuditList: "",
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        } else {
          console.log(error);
        }
      });

    getRequest({ url: "/api/get_audits_count" })
      .then(function (response_count) {
        that.setState({
          AuditsCount: response_count.data.result["0"],
        });
        //console.log(response_count.data.result['0']);
      })
      .catch(function (error) {
        console.log(error);
      });

    getRequest({ url: "/api/get_audits_graph_data" })
      .then(function (response_graph) {
        that.setState({
          GraphData: response_graph.data.result,
        });
        //console.log(response_graph.data.result);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    const NewGraphData = this.state.GraphData;
    function search(nameKey, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].id === nameKey) {
          return myArray[i].name;
        }
      }
    }
    const users = [
      { id: 1, name: "Jan" },
      { id: 2, name: "Feb" },
      { id: 3, name: "Mar" },
      { id: 4, name: "Apr" },
      { id: 5, name: "May" },
      { id: 6, name: "Jun" },
      { id: 7, name: "Jul" },
      { id: 8, name: "Aug" },
      { id: 9, name: "Sep" },
      { id: 10, name: "Oct" },
      { id: 11, name: "Nov" },
      { id: 12, name: "Dec" },
    ];

    for (var j = 0; j < NewGraphData.length; j++) {
      var resultObject = search(NewGraphData[j]["month"], users);
      NewGraphData[j]["month"] = resultObject;
    }

    const AUditDataChart = () => (
      <ResponsiveContainer>
        <AreaChart data={this.state.GraphData} margin={{ top: 10, right: 10, left: -15, bottom: 0 }}>
          <XAxis dataKey="month" axisLine={false} fontSize={10} tickLine={false} padding={{ left: 0, right: 5 }} />
          <YAxis fontSize={10} axisLine={false} tickLine={false} />
          <CartesianGrid stroke="#eee" vertical={false} />
          <Tooltip wrapperStyle={{ borderColor: "#eee" }} />
          <Legend />
          <Area type="monotone" dataKey="audit completed" stackId="1" strokeWidth={2} stroke="#448AFF" fill="#448AFF" fillOpacity=".8" />
          <Area type="monotone" dataKey="rectification completed" stackId="1" strokeWidth={2} stroke="#69F0AE" fill="#69F0AE" fillOpacity=".8" />
        </AreaChart>
      </ResponsiveContainer>
    );

    var size = 5;
    const LatestAuditTable = () => (
      <table className="table">
        <thead></thead>
        <tbody>
          {this.state.LatestAuditList !== ""
            ? this.state.LatestAuditList.map((item, i) => (
                <tr key={i}>
                  <td className="d-flex flex-column">
                    <strong>{item.auditor_name}</strong>
                    <small>{dateFormat(item.audit_date, "mediumDate")}</small>
                  </td>
                  <td className="align-middle">Audit Score {item.audit_score}</td>
                  <td className="align-middle text-nowrap">
                    <IconDot size="12" color={(item.audit_status === 1) | 2 ? "#4CAF50" : "#F44336"} /> &nbsp;
                    {item.audit_status === 1 ? "audit completed" : <span>{item.audit_status === 2 ? "rectification completed" : "audit pending"}</span>}
                  </td>
                </tr>
              ))
            : ""}
        </tbody>
      </table>
    );

    const RecentActivitesTable = () => (
      <div>
        {this.state.LatestAuditList !== ""
          ? this.state.LatestAuditList.map((item, i) => (
              <div className="d-flex mb-4 align-items-center" key={i}>
                <div>
                  <h6 className="font-weight-semi-bold">
                    {item.auditor_name} &nbsp;
                    {item.audit_status === 1 ? "completed a audit" : <span>{item.audit_status === 2 ? "completed rectification" : "started audit"}</span>}
                  </h6>
                  <div className="small"> {dateFormat(item.audit_date, "mediumDate")}</div>
                </div>
              </div>
            ))
          : ""}
      </div>
    );

    const AuditCard = () => (
      <CardGroup className="sales-card mb-4">
        <Card style={{ flex: "3 0 0" }}>
          <CardBlock>
            <CardTitle className="text-uppercase h6">Audit Statistics</CardTitle>
            <div className="small mb-4 card-subtitle">Growth over time</div>
            <div style={{ width: "100%", height: "280px" }}>
              <AUditDataChart />
            </div>
          </CardBlock>
        </Card>
        <Card>
          <CardBlock>
            <h6 className="text-uppercase title font-weight-bold small">Completed Audit</h6>
            <h4 className="font-weight-normal mb-0">{this.state.AuditsCount["audit_complited"]}</h4>
          </CardBlock>
          <CardBlock>
            <h6 className="text-uppercase title font-weight-bold small text-nowrap">Pending Audit</h6>
            <h4 className="font-weight-normal mb-0">{this.state.AuditsCount["rectification_notify"]}</h4>
          </CardBlock>
          <CardBlock>
            <h6 className="text-uppercase title font-weight-bold small">Completed Rectificaiton</h6>
            <h4 className="font-weight-normal mb-0">{this.state.AuditsCount["rectification_complited"]}</h4>
          </CardBlock>
        </Card>
      </CardGroup>
    );

    return (
      <div className="view-content view-dashboard">
        <AuditCard />

        <div></div>
        <Row>
          <div className="col-md-5 mb-4">
            <Card>
              <CardBlock>
                <CardTitle className="h6 text-uppercase">Recent Activities</CardTitle>
                {/* <div className="small mb-4 card-subtitle">At a glance</div> */}

                <RecentActivitesTable />

                {/* <div className="text-right">
                            <button className="btn btn-sm btn-success">View All</button>
                            </div> */}
                <br />
              </CardBlock>
            </Card>
          </div>
          <div className="col-md-7 mb-4">
            <Card>
              <CardBlock className="table-responsive">
                <CardTitle className="text-uppercase h6">Latest Audits</CardTitle>
                {/* <div className="small mb-4 card-subtitle">
                            <Button color="primary" size="sm">View all</Button> 
                            </div> */}
                <LatestAuditTable />
              </CardBlock>
            </Card>
          </div>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/view-content.js